import { Link } from "react-router-dom";
import pehalLogo from "assets/images/Logo.png";
import routeConstants from "routes/routeConstants";

const footerContent = [
  {
    title: "Address ",
    isContent: true,
    address: [
      'Innov8, Okhla Indl. Estate, Phase 3, New Delhi',
      'A-501, SIGNATURE-2, SARKHEJ SANAND HIGHWAY, Sarkhej, Ahmedabad, Sanand, Gujarat, India, 382210',
      '42, Trinity Street, Dorchester, Dorset, England, UK DT1 1TT'
    ],
    // links: [
    //   { path: "/about", name: "About Us" },
    //   { path: "/blog", name: "Blog" },
    //   { path: "login", name: "Login" },
    //   { path: "/register", name: "Register" },
    //   { path: "/forgot-password", name: "Forgot Password" },
    // ],
    isOtherLink: false,
  },
  {
    title: "Company",
    links: [
      { path: "/about", name: "About Us" },
      { path: "/blog", name: "Career" },
      // { path: "login", name: "Job Packages" },
      // { path: "/register", name: "Jobs Featured" },
      // { path: "/forgot-password", name: "Post A Job" },
    ],
    isOtherLink: false,
  },
  {
    title: "Resource",
    links: [
      { path: "/about", name: "Blogs" },
      // { path: "/blog", name: "Freelancer Details" },
      // { path: "login", name: "Project" },
      // { path: "/register", name: "Project Details" },
      // { path: "/forgot-password", name: "Post Project" },
    ],
    isOtherLink: true,
  },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top aos" data-aos="fade-up">
        <div className="container">
          <div className="row">
            {!!footerContent?.length &&
              footerContent?.map((footer, i) => {
                return (
                  <div
                    className={`${!footer?.isOtherLink ? "col-xl-3" : "col-xl-2"
                      } col-md-6`}
                    key={i}
                  >
                    <div className="footer-widget footer-menu">
                      <h2 className="footer-title">{footer?.title}</h2>
                      {footer?.isContent && footer.address.map((h, idx) => (
                        <p key={idx} className="d-flex align-items-start">
                          <i className="fas fa-map-marker-alt mt-1 me-2 text-primary" style={{ minWidth: "16px", fontSize: "14px" }} />
                          <span>{h}</span>
                        </p>
                      ))}
                      <ul>
                        {!!footer?.links?.length &&
                          footer?.links?.map((link, i) => {
                            return (
                              <li key={i}>
                                <Link to={link?.path}>
                                  <i className="fas fa-angle-right me-1" />{" "}
                                  {link?.name}
                                </Link>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                );
              })}
            <div className="col-xl-3 col-md-4">
              <div className="footer-widget footer-menu">
                <h2 className="footer-title">Contact Info</h2>
                <div className="d-flex align-items-center mb-3">
                  <i className="fas fa-envelope text-primary me-2" style={{ fontSize: "16px", minWidth: "16px" }} />
                  <p className="mb-0">sales@pehalgig.com</p>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <i className="fas fa-phone-alt text-primary me-2" style={{ fontSize: "16px", minWidth: "16px" }} />
                  <p className="mb-0">+91 81080 00207</p>
                </div>
                {/* <div
                  className="banner-content aos aos-init aos-animate"
                  data-aos="fade-up"
                >
                  <form className="form" name="store" method="post">
                    <div className="form-inner">
                      <div className="input-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Your Email address....."
                        />
                        <button
                          className="btn btn-primary sub-btn"
                          type="button"
                        >
                          <i className="fas fa-long-arrow-alt-right long-arrow"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div> */}
                <div className="social-icon d-flex">
                  <span>Follow us on : </span>
                  <ul>
                    <li>
                      <Link to="/" className="icon" target="_blank">
                        <i className="fab fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/" className="icon" target="_blank">
                        <i className="fab fa-instagram"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/" className="icon" target="_blank">
                        <i className="fab fa-twitter"></i>{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 col-lg-6 ">
                <div className="footer-bottom-logo">
                  <Link to="/" className="menu-logo">
                    <img src={pehalLogo} className="img-fluid" alt="Logo" />
                  </Link>
                </div>
              </div>
              <div className="col-md-6 col-lg-6 right-text">
                <ul className="nav footer-bottom-nav">
                  {/* <li>
                    <Link to="/">Chat</Link>
                  </li>
                  <li>
                    <Link to="/">Faq</Link>
                  </li>
                  <li>
                    <Link to="/">Reviews</Link>
                  </li> */}
                  <li>
                    <Link to={routeConstants.PRIVACY_POLICY}>
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/">Terms of use</Link>
                  </li>
                </ul>
                <div className="copyright-text">
                  <p className="mb-0">
                    Copyright 2023 © Pehal Gigtech Private Limited. All right
                    reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
